<div class="header-Container">
  @if (reservationNum !='' && reservationNum !==undefined) {
    <div class="row">
      <div class="col-9">
        <h4 class="prodCat-title">Reservation # {{reservationNum}}</h4>
      </div>
    </div>
  }
  <div class="row">
    <div class="col-8">
      <span class="activeSeasonId">
        {{activeSeasonId}} {{'selectVaccines.season'|cxTranslate}}
      </span>
      @if (reservationStatus !== '' && reservationStatus !==undefined) {
        <span class="activeSeasonId">
          | {{reservationStatus}}
        </span>
      }
      @if (reservationStatus !== '' && reservationStatus !==undefined) {
        <span>
          @if (reservationStatus === 'Confirmed') {
            <img class="mb-2 ml-1" src="/icons/confirm.png"
              alt="status" />
          }
          @if (reservationStatus === 'Partially confirmed') {
            <img class="mb-2 ml-1"
              src="/icons/part-confirm.png" alt="status" />
          }
          @if (reservationStatus === 'Not confirmed') {
            <img class="mb-2 ml-1" src="/icons/not-confirm.png"
              alt="status" />
          }
        </span>
      }
      @if (reservationStatus == 'Not confirmed' || reservationStatus == 'Partially confirmed') {
        <span
          class="ml-3 red-text not-confirmed-flu-uniq" [innerHTML]="notConfirmedMessage">
        </span>
      }
    </div>
    <div class="col-12 bc-Dash-Div no-print">
      <a (click)='backToDashboard()'>
        <img src='/icons/{{baseSiteId}}/chevron-left_green.svg' class="svg-Images" alt="left">
      {{'selectVaccines.back_to_db'|cxTranslate}}</a>&nbsp;&nbsp;
      <a class="excel-download mr-1" (click)="exportXls()"><img class="mr-1 w-auto"
        src="/icons/{{baseSiteId}}/excel_new.png" alt="XLS" />
      <span>{{ "orderDetail.xls" | cxTranslate }}</span></a>&nbsp;&nbsp;
      <a class="print mr-3" (click)="OnFluPrint()">
        <img src="/icons/{{baseSiteId}}/print.svg" class="svg-Images" alt="print">
      {{'selectVaccines.print'|cxTranslate}}</a>
    </div>
  </div>
</div>
@if (stsFlag && (reservationStatus === 'Confirmed' || reservationStatus === 'Shipped')) {
  <div class="reservation-style">
    <div class="row">
      <div class="col-xs-12 col-md-12 col-sm-12 col-lg-12 reservation-dashboard">
        <div class="tabs-Section-Container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-9 col-lg-10 large-Device-Tabs">
              <ul class="nav nav-tabs">
                <li class="nav-item mr-3 p-overview"
                  [ngClass]="{'nav-Item-Border': tabSelected == 'reservationOverview'}">
                  <span (click)="tabNavigation('reservationOverview', 'reservationOverview')">
                    {{'Overview'}}
                  </span>
                </li>
                <li class="nav-item p-schedule" [ngClass]="{'nav-Item-Border': tabSelected == 'reservationSchedule'}">
                  <span (click)="tabNavigation('reservationSchedule', 'reservationSchedule')">
                    {{'Shipping schedule'}}
                  </span>
                </li>
              </ul>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-2 edit-reservation-btn-mobile-view">
              @if (reservationStatus === 'Confirmed' && showEditCTAShip) {
                <button class="btn-secondary edit-res"
                [hidden]="userReceivingHours" (click)="redirectToSelectVaccine()">Edit reservation</button>
              }
            </div>
          </div>
        </div>
        <div class="tab-contents">
          <div id="reservationOverview">
            <app-reservation-overview [reservationNo]="reservationNum"
            (tabSelectedEvent)="tabNavigation('reservationSchedule', 'reservationSchedule')"></app-reservation-overview>
          </div>
          <div id="reservationSchedule">
            <app-reservation-sts-details [reservationNo]="reservationNum"></app-reservation-sts-details>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (!stsFlag &&(reservationStatus === 'Confirmed' || reservationStatus === 'Shipped')) {
  <div class="reservation-style"
    >
    <div class="col">
      <div class="col-xs-12 col-md-12 col-sm-12 col-lg-12 reservation-dashboard">
        <div class="tabs-Section-Container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 large-Device-Tabs">
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              @if (reservationStatus === 'Confirmed' && showEditCTAShip) {
                <button class="btn-secondary float-right edit-res"
                [hidden]="userReceivingHours" (click)="redirectToSelectVaccine()">Edit reservation</button>
              }
            </div>
          </div>
        </div>
        <div class="tab-contents">
          <div>
            <app-reservation-overview [reservationNo]="reservationNum"></app-reservation-overview>
          </div>
        </div>
      </div>
    </div>
  </div>
}
